<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0264 12.8482L17.0891 15.9108C17.4145 16.2363 17.4145 16.7639 17.0891 17.0893C16.7637 17.4148 16.236 17.4148 15.9106 17.0893L12.8479 14.0267C11.5648 15.053 9.93735 15.6667 8.1665 15.6667C4.02437 15.6667 0.666504 12.3089 0.666504 8.16675C0.666504 4.02461 4.02437 0.666748 8.1665 0.666748C12.3086 0.666748 15.6665 4.02461 15.6665 8.16675C15.6665 9.93759 15.0528 11.5651 14.0264 12.8482ZM8.1665 14.0001C11.3882 14.0001 13.9998 11.3884 13.9998 8.16675C13.9998 4.94509 11.3882 2.33341 8.1665 2.33341C4.94484 2.33341 2.33317 4.94509 2.33317 8.16675C2.33317 11.3884 4.94484 14.0001 8.1665 14.0001Z"
      fill="#0F2D5A"
    />
  </svg>
</template>
